import * as actionTypes from '../../constants/actionTypes';

const initialState = {
  orderedBySku: [],
  orderedByName: [],
};

export default function(state = initialState, action) {
  switch (action.type) {
    case actionTypes.FETCH_PRODUCT_LIST_SUCCESS:
    case actionTypes.FETCH_PRODUCT_LIST_ERROR:
      const orderedByName = action.payload.productGists.map(product => {
        return {
          label: product.productName,
          value: product.skuCode,
        };
      });
      const orderedBySku = action.payload.productGists.map(product => {
        return {
          label: product.skuCode,
          value: product.productName,
        };
      });
      return { orderedByName, orderedBySku };
    case actionTypes.UNLOAD_PRODUCTS:
      return initialState;
    default:
      return state;
  }
}
